/* Spanial: cart and wishlist behaviour.
   Two jobs.
   1. Add to cart without a page reload. Horizon posts the product form and
      reloads the whole document, which on a 3G phone in Kannur reads as
      "nothing happened". We POST to /cart/add.js instead and confirm inline.
   2. Wishlist in localStorage. Per browser, no account needed. Moves to
      customer metafields later without changing this API.
*/
(function () {
  'use strict';

  var WKEY = 'spanial_wishlist_v1';
  var money = function (cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };

  /* ---------------- wishlist store ---------------- */

  function wlRead() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; }
    catch (e) { return []; }
  }
  function wlWrite(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    wlPaintCount();
    document.dispatchEvent(new CustomEvent('spanial:wishlist', { detail: list }));
  }
  function wlHas(handle) { return wlRead().indexOf(handle) > -1; }
  function wlToggle(handle) {
    var list = wlRead();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    wlWrite(list);
    return list.indexOf(handle) > -1;
  }
  function wlPaintCount() {
    var n = wlRead().length;
    document.querySelectorAll('[data-sp-wl-count]').forEach(function (el) {
      el.textContent = n ? String(n) : '';
      el.hidden = n === 0;
    });
  }
  window.SpanialWishlist = { read: wlRead, has: wlHas, toggle: wlToggle };

  /* ---------------- toast ---------------- */

  var toastEl = null, toastTimer = null;
  function toast(msg, href, label) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + msg + '</span>' +
      (href ? ' <a href="' + href + '">' + (label || 'View') + '</a>' : '');
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* ---------------- cart count ---------------- */

  function paintCartCount(count) {
    document.querySelectorAll('[data-sp-cart-count], .cart-bubble__text, .header-actions__cart-count')
      .forEach(function (el) {
        el.textContent = count > 0 ? String(count) : '';
        if (el.hasAttribute('data-sp-cart-count')) el.hidden = count === 0;
      });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCartCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------------- add to cart, no reload ---------------- */

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    ev.preventDefault();

    var btn = form.querySelector('[type="submit"], .sp-atc');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); btn.textContent = 'Adding'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body && res.body.description ? res.body.description : 'Could not add that one.');
          return;
        }
        var name = res.body.product_title || 'Item';
        toast(name + ' added to your bag.', '/cart', 'View bag');
        refreshCartCount();
      })
      .catch(function () { toast('Network problem. Try once more.'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.textContent = original; }
      });
  });

  /* ---------------- cart page: qty and remove, no reload ---------------- */

  function cartChange(line, quantity, row) {
    if (row) row.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCartCount(cart.item_count);
        if (quantity === 0 || cart.item_count === 0) { window.location.reload(); return; }
        var item = cart.items[line - 1];
        if (item && row) {
          var lp = row.querySelector('[data-sp-line-price]');
          if (lp) lp.textContent = money(item.final_line_price);
          var qi = row.querySelector('[data-sp-qty-value]');
          if (qi) qi.value = item.quantity;
        }
        var sub = document.querySelector('[data-sp-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        var cnt = document.querySelector('[data-sp-cart-items]');
        if (cnt) cnt.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      })
      .catch(function () { toast('Could not update the bag.'); })
      .finally(function () { if (row) row.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-sp-qty], [data-sp-remove], [data-sp-wl]');
    if (!t) return;

    if (t.hasAttribute('data-sp-wl')) {
      ev.preventDefault();
      var handle = t.getAttribute('data-sp-wl');
      var on = wlToggle(handle);
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
      toast(on ? 'Saved to your wishlist.' : 'Removed from your wishlist.',
            on ? '/pages/wishlist' : null, 'View wishlist');
      return;
    }

    var row = t.closest('[data-sp-line]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-sp-line'), 10);

    if (t.hasAttribute('data-sp-remove')) {
      ev.preventDefault();
      cartChange(line, 0, row);
      return;
    }

    var input = row.querySelector('[data-sp-qty-value]');
    if (!input) return;
    var next = parseInt(input.value, 10) + (t.getAttribute('data-sp-qty') === 'up' ? 1 : -1);
    if (next < 1) next = 1;
    input.value = next;
    cartChange(line, next, row);
  });

  /* ---------------- paint wishlist state on load ---------------- */

  function paintWishlistButtons() {
    document.querySelectorAll('[data-sp-wl]').forEach(function (b) {
      var on = wlHas(b.getAttribute('data-sp-wl'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() { paintWishlistButtons(); wlPaintCount(); refreshCartCount(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', paintWishlistButtons);
})();
